module.exports = __webpack_public_path__ + "static/media/Asset 5@3x.d5858895.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Avatar/Asset 5@3x.png
// module id = 2391
// module chunks = 0